<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('projectName1')">
          <Input clearable v-model="projectName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectNumber1')">
          <Input clearable v-model="projectNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceContractNo2')">
          <Input clearable v-model="serviceContractNo" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskNumber1')">
          <Input clearable v-model="taskNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('subtaskName1')">
          <Input clearable v-model="subtaskName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('subtaskNumber1')">
          <Input clearable v-model="subtaskNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('actualDeliveryEngineer2')">
          <el-select v-model="actualDeliveryEngineer" clearable filterable remote :remote-method="remoteEngineer">
            <el-option v-for="item in DeliveryEngineerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('subtaskStatus1')" v-if="queryShow">
          <el-select v-model="subtaskStatus" clearable>
            <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceStartDate1')" v-if="queryShow">
          <el-date-picker v-model="serviceStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceEndDate1')" v-if="queryShow">
          <el-date-picker v-model="serviceEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('country1')" v-if="queryShow">
          <el-select filterable v-model="country" clearable>
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('department1')" v-if="queryShow">
          <el-select filterable v-model="department" clearable>
            <el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" @click="advancedFilter">{{$t('advancedFilter')}}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchSubtaskByPage" :loading="searchLoading">{{$t('search')}}</el-button>
          <el-button v-has="{class:'subtaskExport'}" type="primary" size="mini" icon="el-icon-download" @click="exportExcel">{{$t('export')}}</el-button>
          <el-button v-has="{class:'subtaskAdd'}" type="primary" size="mini" icon="el-icon-plus" @click="addInfo">{{$t('add')}}</el-button>
        </div>
      </Form>
      <div class="contentTableDiv">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" v-if="false"></el-table-column> 
          <el-table-column prop="subtaskName" :label="$t('subtaskName')" align="left" :show-overflow-tooltip="true" min-width="300">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.subtaskName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="subtaskStatus" :label="$t('subtaskStatus')" align="center" min-width="130"></el-table-column>
          <el-table-column prop="actualDeliveryEngineer" :label="$t('actualDeliveryEngineer')" align="center" width="185" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="plannedLabourHour" :label="$t('totalPlannedHour')" align="center" min-width="210"></el-table-column>
          <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="200">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleProject(scope.row)">{{scope.row.projectName}}</a>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="taskName" :label="$t('taskName')" align="left" :show-overflow-tooltip="true" min-width="200">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleTask(scope.row)">{{scope.row.taskName}}</a>
            </template>
          </el-table-column> -->
          <el-table-column prop="labourSum" :label="$t('labourSum')" align="center" :show-overflow-tooltip="true" min-width="140">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleLabour(scope.row)">{{scope.row.labourSum}}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('operate')" fixed="right" width="130" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click" v-if="scope.row.flagStatus!='1'&&scope.row.flagStatus!='3'">
                <el-button size="mini" type="primary">{{$t('operate')}}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item><el-button v-has="{class:'subtaskLabour'}" v-if="scope.row.flagStatus=='0'&&scope.row.showAdd=='0'" size="mini" type="primary" @click="addLabour(scope.row)">{{$t('addLabour')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'subtaskUpdate'}" v-if="scope.row.flagStatus=='0'" size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'subtaskFreeze'}" v-if="scope.row.flagStatus=='0'" size="mini" type="danger" @click="handleFreeze(scope.row)">{{$t('freeze')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'subtaskClone'}" v-if="scope.row.flagStatus=='0'" size="mini" type="primary" @click="handleClone(scope.row)">{{$t('clone')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'subtaskUnfreeze'}" v-if="scope.row.flagStatus=='2'" size="mini" type="danger" @click="handleUnFreeze(scope.row)">{{$t('unFreeze')}}</el-button></el-dropdown-item>
                  <el-dropdown-item><el-button v-has="{class:'subtaskDelete'}" v-if="scope.row.labourSum==0" size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
    <el-card>
      <el-collapse >
        <el-collapse-item name="1">
          <template slot="title"><span style="font-size: 18px;">Frozen/Closed Subtask List<i class="header-icon el-icon-caret-bottom"></i></span></template>
          <!-- 查询选项 -->
          <Form class="salesmanForm" :label-width="160">
            <FormItem class="form_item" :label="$t('projectName1')">
              <Input clearable v-model="frozenPaName" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('projectNumber1')">
              <Input clearable v-model="frozenPaNumber" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('serviceContractNo2')">
              <Input clearable v-model="frozenContractNo" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('taskNumber1')">
              <Input clearable v-model="frozenTaNumber" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('subtaskName1')">
              <Input clearable v-model="frozenSubName" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('subtaskNumber1')">
              <Input clearable v-model="frozenSubNumber" :placeholder="$t('enter')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('actualDeliveryEngineer2')">
              <el-select v-model="frozenSubEngineer" clearable filterable remote :remote-method="remoteFrozenEngineer">
                <el-option v-for="item in FrozenEngineerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('subtaskStatus1')" v-if="filterShow">
              <el-select v-model="frozenSubStatus" clearable>
                <el-option v-for="item in FrozenStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('serviceStartDate1')" v-if="filterShow">
              <el-date-picker v-model="frozenSubStartDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('serviceEndDate1')" v-if="filterShow">
              <el-date-picker v-model="frozenSubEndDate" :editable="true" :clearable="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('selectdate')"/>
            </FormItem>
            <FormItem class="form_item" :label="$t('country1')" v-if="filterShow">
              <el-select filterable v-model="frozenCountry" clearable>
                <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
              </el-select>
            </FormItem>
            <FormItem class="form_item" :label="$t('department1')" v-if="filterShow">
              <el-select filterable v-model="frozenDepartment" clearable>
                <el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
              </el-select>
            </FormItem>
            <div class="buttonDiv">
              <el-button type="primary" size="mini" @click="frozenFilter">{{$t('advancedFilter')}}</el-button>
              <el-button type="primary" size="mini" @click="searchFrozenSubtaskList" :loading="searchFrozenLoading">{{$t('search')}}</el-button>
              <el-button v-has="{class:'subtaskExport'}" type="primary" size="mini" @click="frozenExcel">{{$t('export')}}</el-button>
            </div>
          </Form>
          <div class="contentTableDiv">
            <el-table :data="FrozenData" @selection-change="frozenSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column prop="id" v-if="false"></el-table-column> 
              <el-table-column prop="subtaskName" :label="$t('subtaskName')" align="left" :show-overflow-tooltip="true" min-width="300">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.subtaskName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="subtaskStatus" :label="$t('subtaskStatus')" align="center" min-width="130"></el-table-column>
              <el-table-column prop="actualDeliveryEngineer" :label="$t('actualDeliveryEngineer')" align="center" width="185" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="plannedLabourHour" :label="$t('totalPlannedHour')" align="center" min-width="210"></el-table-column>
              <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="200">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleProject(scope.row)">{{scope.row.projectName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="taskName" :label="$t('taskName')" align="left" :show-overflow-tooltip="true" min-width="200">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleTask(scope.row)">{{scope.row.taskName}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="labourSum" :label="$t('labourSum')" align="center" :show-overflow-tooltip="true" min-width="140">
                <template slot-scope="scope">
                  <a style="color:blue;" @click="handleLabour(scope.row)">{{scope.row.labourSum}}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('operate')" fixed="right" width="130" align="center">
                <template slot-scope="scope">
                  <el-button v-has="{class:'subtaskUnfreeze'}" v-if="scope.row.flagStatus=='2'" size="mini" type="danger" @click="handleUnFreeze(scope.row)">{{$t('unFreeze')}}</el-button>
                </template>
              </el-table-column>
            </el-table> 
          </div>
          <div class="pageDiv">
            <el-pagination small @size-change="changeFrozenPageSize" @current-change="changeFrozenPage" :current-page="currentFrozenPage" :page-sizes="[10, 20,50,100]"
              :page-size="pageFrozenSize" layout="total, prev, pager, next, sizes, jumper" :total="totalFrozenCount">
            </el-pagination>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <Modal v-model="modelFreeze" :closable='true' :mask-closable='false' :title="$t('freezingReason')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitFreezeForm('freezeForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="freezeForm" ref="freezeForm" :rules="rules" >
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item prop="freezingReason" >
                <el-input v-model="freezeForm.freezingReason" type="textarea" :rows="4" :placeholder="$t('reason')"/>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
    <Modal v-model="modelUnFreeze" :closable='true' :mask-closable='false' :title="$t('unFreezingReason')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitUnFreezeForm('unFreezeForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="unFreezeForm" ref="unFreezeForm" :rules="rules" >
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item prop="unFreezingReason" >
                <el-input v-model="unFreezeForm.unFreezingReason" type="textarea" :rows="4" :placeholder="$t('reason')"/>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
  </div>
</template>
<script>
    import {_debounce} from '@/utils/selectAPI'
    import * as validate from '@/utils/validate'

    export default {
        name: 'subtask',
        activated () {
          let toSubtask = this.$route.params.toSubtask;
          if(toSubtask == 'N'){
            this.getSubtaskByPage();
          }
        },
        created () {
          // this.getParams();
          this.getSubtaskByPage();
          this.getDeliveryEngineerList();
          this.getCountry();
          this.getDeptList();
          this.getFrozenSubtaskList();
        },
        data () {
          return {
            rangeNumber: 10,
            projectName:null,
            projectNumber:null,
            serviceContractNo:null,
            taskNumber:null,
            subtaskName:null,
            subtaskNumber:null,
            actualDeliveryEngineer:null,
            subtaskStatus:null,
            serviceStartDate:null,
            serviceEndDate:null,
            country:null,
            department:null,
            //Frozen
            frozenPaName:null,
            frozenPaNumber:null,
            frozenContractNo:null,
            frozenTaNumber:null,
            frozenSubName:null,
            frozenSubNumber:null,
            frozenSubEngineer:null,
            frozenSubStatus:null,
            frozenSubStartDate:null,
            frozenSubEndDate:null,
            frozenCountry:null,
            frozenDepartment:null,
            //other
            filterShow:false,
            queryShow:false,
            freezeForm:{
              freezingReason:null,
            },
            unFreezeForm:{
              unFreezingReason:null,
            },
            StatusList:[
              { value: 'ToDelivered',label: 'Waiting for Delivery'},
              { value: 'Delivered',label: 'Delivering'},
              { value: 'DeliveryCompleted',label: 'Fully Delivered'},
            ],
            FrozenStatus:[
              { value: 'Frozen',label: 'Frozen'},
              { value: 'Closed',label: 'Closed'},
            ],
            CountryList:[],
            DeptList:[],
            DeEngineerList:[],
            DeliveryEngineerList:[],
            FrozenEngineerList:[],
            subtNumber:null,
            subtName:null,
            subtEngineer:null,
            subtaskId:null,
            modelFreeze:false,
            modelUnFreeze:false,
            exportLoading:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            frozenSelection: [],
            tableData: [],
            FrozenData: [],
            currentFrozenPage: 1,
            totalFrozenCount: 0,
            pageFrozenSize: 10,
            rules: {
              freezingReason: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
              unFreezingReason: [
                { required: true, message:'Please input value', trigger: 'blur' },
              ],
            },
            searchLoading: false,
            searchFrozenLoading: false,
          }
        },
        methods: {
          getParams(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
              let params = this.$route.params;
              this.currentPage = params.currentPage;
              this.pageSize = params.pageSize;
              this.projectName = params.projectName;
              this.projectNumber = params.projectNumber;
              this.serviceContractNo = params.serviceContractNo;
              this.taskNumber = params.taskNumber;
              this.subtaskName = params.subtaskName;
              this.subtaskNumber = params.subtaskNumber;
              this.actualDeliveryEngineer = params.actualDeliveryEngineer;
              this.subtaskStatus = params.subtaskStatus;
              this.serviceStartDate = params.serviceStartDate;
              this.serviceEndDate = params.serviceEndDate;
              this.country = params.country;
              this.department = params.department;
            }
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptCodechain: 'SelectDept',
            }
            this._post(url,pm).then(
              res => {   
                this.DeptList = res.data;
              }
            )
          },
          getDeliveryEngineerList(){
            let url =`${this.$store.state.islhurl}user/getSelectDeliveryEngineer`;
            this._post(url).then(
              res => {   
                this.DeEngineerList = res.data;
                this.DeliveryEngineerList = res.data;
                this.FrozenEngineerList = res.data;
              }
            )
          },
          getSubtaskByPage(){
            let projectId = this.$route.params.projectNumber;
            if(projectId != undefined && projectId != null && projectId != ''){
              this.projectNumber = projectId;
            }
            let taskId = this.$route.params.taskNumber;
            if(taskId != undefined && taskId != null && taskId != ''){
              this.taskNumber = taskId;
            }
            let url = `${this.$store.state.islhurl}getSubtaskInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskId: this.taskNumber==''?null:this.taskNumber,
              subtaskName: this.subtaskName==''?null:this.subtaskName,
              subtaskNumber: this.subtaskNumber==''?null:this.subtaskNumber,
              projectName: this.projectName==''?null:this.projectName,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              actualDeliveryEngineer: this.actualDeliveryEngineer==''?null:this.actualDeliveryEngineer,
              subtaskStatus: this.subtaskStatus==''?null:this.subtaskStatus,
              serviceStartDate: this.serviceStartDate==''?null:this.serviceStartDate,
              serviceEndDate: this.serviceEndDate==''?null:this.serviceEndDate,
              country: this.country==''?null:this.country,
              dept: this.department==''?null:this.department,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(pm)
            this._post(url,pm).then(
              res =>{
                this.tableData = res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          searchSubtaskByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let url = `${this.$store.state.islhurl}getSubtaskInfo/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskId: this.taskNumber==''?null:this.taskNumber,
              subtaskName: this.subtaskName==''?null:this.subtaskName,
              subtaskNumber: this.subtaskNumber==''?null:this.subtaskNumber,
              projectName: this.projectName==''?null:this.projectName,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              actualDeliveryEngineer: this.actualDeliveryEngineer==''?null:this.actualDeliveryEngineer,
              subtaskStatus: this.subtaskStatus==''?null:this.subtaskStatus,
              serviceStartDate: this.serviceStartDate==''?null:this.serviceStartDate,
              serviceEndDate: this.serviceEndDate==''?null:this.serviceEndDate,
              country: this.country==''?null:this.country,
              dept: this.department==''?null:this.department,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchLoading = true
            this._post(url,pm).then(
              res =>{
                this.tableData = res.data;
                this.totalCount = res.totalNums;
                this.searchLoading = false
              }
            ).catch(e => {
              this.searchLoading = false
            })
          },
          getFrozenSubtaskList(){
            let url = `${this.$store.state.islhurl}getFrozenSubtaskList/${this.pageFrozenSize}/${this.currentFrozenPage}`
            let pm = {
              projectName: this.frozenPaName==''?null:this.frozenPaName,
              projectId: this.frozenPaNumber==''?null:this.frozenPaNumber,
              serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
              taskId: this.frozenTaNumber==''?null:this.frozenTaNumber,
              subtaskName: this.frozenSubName==''?null:this.frozenSubName,
              subtaskNumber: this.frozenSubNumber==''?null:this.frozenSubNumber,
              actualDeliveryEngineer: this.frozenSubEngineer==''?null:this.frozenSubEngineer,
              subtaskStatus: this.frozenSubStatus==''?null:this.frozenSubStatus,
              serviceStartDate: this.frozenSubStartDate==''?null:this.frozenSubStartDate,
              serviceEndDate: this.frozenSubEndDate==''?null:this.frozenSubEndDate,
              country: this.frozenCountry==''?null:this.frozenCountry,
              dept: this.frozenDepartment==''?null:this.frozenDepartment,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.FrozenData = res.data;
                this.totalFrozenCount = res.totalNums;
              }
            )
          },
          searchFrozenSubtaskList(){
            this.pageFrozenSize = 10;
            this.currentFrozenPage = 1;
            let url = `${this.$store.state.islhurl}getFrozenSubtaskList/${this.pageFrozenSize}/${this.currentFrozenPage}`
            let pm = {
              projectName: this.frozenPaName==''?null:this.frozenPaName,
              projectId: this.frozenPaNumber==''?null:this.frozenPaNumber,
              serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
              taskId: this.frozenTaNumber==''?null:this.frozenTaNumber,
              subtaskName: this.frozenSubName==''?null:this.frozenSubName,
              subtaskNumber: this.frozenSubNumber==''?null:this.frozenSubNumber,
              actualDeliveryEngineer: this.frozenSubEngineer==''?null:this.frozenSubEngineer,
              subtaskStatus: this.frozenSubStatus==''?null:this.frozenSubStatus,
              serviceStartDate: this.frozenSubStartDate==''?null:this.frozenSubStartDate,
              serviceEndDate: this.frozenSubEndDate==''?null:this.frozenSubEndDate,
              country: this.frozenCountry==''?null:this.frozenCountry,
              dept: this.frozenDepartment==''?null:this.frozenDepartment,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchFrozenLoading = true
            this._post(url,pm).then(
              res =>{
                this.FrozenData = res.data;
                this.totalFrozenCount = res.totalNums;
                this.searchFrozenLoading = false
              }
            ).catch(e => {
              this.searchFrozenLoading = false
            })
          },
          addInfo() {
            this.$router.push({path:'/subtask/add'});
          },
          handleNavigation(index){
            let pm = {
              id: index.id,
              showRun:'Y',
            }
            this.$router.push({name:'subtask_detail',params:pm})
          },
          handleProject(index){
            let pm = {
              projectNumber: index.projectId,
            }
            this.$router.push({name:'project_detail',params:pm});
          },
          handleTask(index){
            let pm = {
              taskNumber: index.taskId,
            }
            this.$router.push({name:'task_detail',params:pm});
          },
          handleLabour(index){
            let pm = {
              subtaskNumber: index.subtaskNumber,
              toLabour: 'N',
            }
            let role = sessionStorage.getItem("roleName");
            if(role.indexOf("Engineer") != -1){
              this.$router.push({name:'labourEngineer',params:pm});
              this.$store.commit('tagChange', 'labourEngineer');
            }else{
              this.$router.push({name:'labour',params:pm});
              this.$store.commit('tagChange', 'labour');
            }
          },
          addLabour(index) {
            let url =`${this.$store.state.islhurl}subtask/getSubtaskToHour`;
            let pm = {
              subtaskNumber : index.subtaskNumber,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res => {
                if (res.subtask) {
                  let obj = {
                    ...res.subtask
                  }
                  this.$router.push({name:'labourEnter',params:obj});
                  this.$store.commit('tagChange', 'labourEnter');
                }
              }
            )
          },
          handleEdit(index) {
            let pm = {
              id: index.id,
            }
            this.$router.push({name:'subtask_edit',params:pm})
          },
          handleFreeze(index){
            this.subtaskId = index.id;
            this.subtName = index.subtaskName;
            this.subtNumber = index.subtaskNumber;
            this.subtEngineer = index.actualDeliveryEngineer;
            this.freezeForm.freezingReason = null;
            this.modelFreeze = true;
          },
          submitFreezeForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.freezeInfo();
              } else {
                return false;
              }
            });
          },
          freezeInfo(){
            let params = {
              id:this.subtaskId,
              subtaskName:this.subtName,
              subtaskNumber:this.subtNumber,
              subtaskEngineer:this.subtEngineer,
              freezingReason:this.freezeForm.freezingReason,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}subtask/freezeInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getSubtaskByPage();
                  this.getFrozenSubtaskList();
                  this.modelFreeze = false;
                  this.$Message.success('Freeze successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          handleUnFreeze(index){
            this.subtaskId = index.id;
            this.subtNumber = index.subtaskNumber;
            this.unFreezeForm.unFreezingReason = null;
            this.modelUnFreeze = true;
          },
          submitUnFreezeForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.unFreezeInfo();
              } else {
                return false;
              }
            });
          },
          unFreezeInfo(){
            let params = {
              id:this.subtaskId,
              subtaskNumber:this.subtNumber,
              unfreezingReason:this.unFreezeForm.unFreezingReason,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}subtask/unFreezeInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.getSubtaskByPage();
                  this.getFrozenSubtaskList();
                  this.modelUnFreeze = false;
                  this.$Message.success('unFreeze successful' )
                }else{
                  this.$message.error(res);
                }
              }
            )
          },
          handleClone(index){
            let pm = {
              addFlag: 'Clone',
              projectId: index.projectId,
              taskId: index.taskId,
              taskName: index.taskName,
              tsType: index.taskType,
              actualDeliveryEngineer: index.actualDeliveryEngineer,
              subtaskStatus: index.subtaskStatus,
              subtaskName: index.subtaskName,
              serviceStartDate: index.serviceStartDate,
              serviceEndDate: index.serviceEndDate,
              deliveryEngineerCity: index.deliveryEngineerCity,
              deliveryAddress: index.deliveryAddress,
              plannedLabourHour: index.plannedLabourHour,
              isStationin: index.isStationin,
              subtaskRemark: index.subtaskRemark,
              quantityMark: index.quantityMark,
              groupId: index.groupId,
            }
            this.$router.push({name:'subtask_add',params:pm})
          },
          handleDelete(index){
            this.$confirm("Are you sure to delete the subtask", "Warning", {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              let params = {
                id:index.id,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}subtask/deleteInfo`
              this._post(url,params).then(
                res =>{
                  if(res=="200"){
                    this.getSubtaskByPage();
                    this.$Message.success('Subtask Delete Successful' )
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            }).catch(() => {
            });
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'SubtaskInfo.xlsx';
            const length = this.multipleSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}subtask/exportInfo`,
              method: 'post',
              data: {
                ids: ids,
                projectId: this.projectNumber==''?null:this.projectNumber,
                taskId: this.taskNumber==''?null:this.taskNumber,
                subtaskName: this.subtaskName==''?null:this.subtaskName,
                subtaskNumber: this.subtaskNumber==''?null:this.subtaskNumber,
                projectName: this.projectName==''?null:this.projectName,
                serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
                actualDeliveryEngineer: this.actualDeliveryEngineer==''?null:this.actualDeliveryEngineer,
                subtaskStatus: this.subtaskStatus==''?null:this.subtaskStatus,
                serviceStartDate: this.serviceStartDate==''?null:this.serviceStartDate,
                serviceEndDate: this.serviceEndDate==''?null:this.serviceEndDate,
                country: this.country==''?null:this.country,
                dept: this.department==''?null:this.department,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          frozenSelectionChange(val) {
            this.frozenSelection = val;
          },
          frozenExcel(){
            this.exportLoading = true;
            let execlName = 'SubtaskInfo.xlsx';
            const length = this.frozenSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.frozenSelection[i].id)
            }
            this.$axios({
              url: `${this.$store.state.islhurl}subtask/exportFrozenExcel`,
              method: 'post',
              data: {
                ids: ids,
                projectName: this.frozenPaName==''?null:this.frozenPaName,
                projectId: this.frozenPaNumber==''?null:this.frozenPaNumber,
                serviceContractNo: this.frozenContractNo==''?null:this.frozenContractNo,
                taskId: this.frozenTaNumber==''?null:this.frozenTaNumber,
                subtaskName: this.frozenSubName==''?null:this.frozenSubName,
                subtaskNumber: this.frozenSubNumber==''?null:this.frozenSubNumber,
                actualDeliveryEngineer: this.frozenSubEngineer==''?null:this.frozenSubEngineer,
                subtaskStatus: this.frozenSubStatus==''?null:this.frozenSubStatus,
                serviceStartDate: this.frozenSubStartDate==''?null:this.frozenSubStartDate,
                serviceEndDate: this.frozenSubEndDate==''?null:this.frozenSubEndDate,
                country: this.frozenCountry==''?null:this.frozenCountry,
                dept: this.frozenDepartment==''?null:this.frozenDepartment,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          close(){
            this.$refs.freezeForm.resetFields();
            this.$refs.unFreezeForm.resetFields();
            this.modelFreeze = false;
            this.modelUnFreeze = false;
          },
          advancedFilter(){
            if(this.queryShow){
              this.queryShow = false;
              this.subtaskStatus = null;
              this.serviceStartDate = null;
              this.serviceEndDate = null;
              this.country = null;
              this.department = null;
            }else{
              this.queryShow = true;
            }
          },
          frozenFilter(){
            if(this.filterShow){
              this.filterShow = false;
              this.frozenSubStatus = null;
              this.frozenSubStartDate = null;
              this.frozenSubEndDate = null;
              this.frozenCountry = null;
              this.frozenDepartment = null;
            }else{
              this.filterShow = true;
            }
          },
          changePage (val) {
            this.currentPage = val;
            this.getSubtaskByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getSubtaskByPage();
          },
          changeFrozenPage (val) {
            this.currentFrozenPage = val;
            this.getFrozenSubtaskList();
          },
          changeFrozenPageSize (val) {
            this.pageFrozenSize = val;
            this.getFrozenSubtaskList();
          },
          remoteEngineer(query) {
            if (query !== '') {
              setTimeout(() => {
                this.DeliveryEngineerList = this.DeEngineerList.filter(item => {
                  return item.userCode.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.DeliveryEngineerList = this.DeEngineerList;
            }
          },
          remoteFrozenEngineer(query) {
            if (query !== '') {
              setTimeout(() => {
                this.FrozenEngineerList = this.DeEngineerList.filter(item => {
                  return item.userCode.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.FrozenEngineerList = this.DeEngineerList;
            }
          },
        },
    }
</script>



// WEBPACK FOOTER //
// src/view/subtask/subtaskList.vue